import React from "react"
import "./footer.css"

function Footer() {
  return (
    <div data-scroll-section className="bg-reverse">
      <div className="container-fluid footer-container">
        <div className="border-light"></div>
        <p className="text-medium">
          Ethiopia is the latest destination to be awarded the{" "}
          <span className="clr-accent">
            World Travel & Tourism Council (WTTC)
          </span>{" "}
          Safe Travels Stamp – the world’s first-ever global safety and hygiene
          stamp to ensure safety for residents, travelers, and workers and
          businesses in the tourism value chain, as Ethiopia reopened its
          borders to international visitors.
        </p>
        <div className="footer-grid">
          <div className="footer-links">
            <ul>
              <li>
                <p className="muted">About</p>
              </li>
              <li>
                <a href="!#">History</a>
              </li>
              <li>
                <a href="!#">Lifestyle</a>
              </li>
              <li>
                <a href="!#">About us</a>
              </li>
            </ul>
            <ul>
              <li>
                <p className="muted">Destinations</p>
              </li>
              <li>
                <a href="!#">The historic north</a>
              </li>
              <li>
                <a href="!#">The cultural south</a>
              </li>
              <li>
                <a href="!#">The marvel of east</a>
              </li>
              <li>
                <a href="!#">The afar triangle</a>
              </li>
            </ul>
            <ul>
              <li>
                <p className="muted">Plan your trip</p>
              </li>
              <li>
                <a href="!#">Get your visa</a>
              </li>
              <li>
                <a href="!#">Book your flight</a>
              </li>
              <li>
                <a href="!#">When to travel</a>
              </li>
            </ul>
          </div>
          <div className="footer-email">
            <p className="muted">Join our community for more!</p>
            <div className="input-box">
              <input type="email" placeholder="enter your email" />
              <button className="btn btn-email">Join</button>
            </div>
          </div>
        </div>
        <div className="border-light"></div>
        <div className="footer-footer">
          <p className="serif">
            Land of <span className="clr-accent">Origins</span> © 2021, All
            rights reserved!
          </p>
        </div>
      </div>
    </div>
  )
}

export default Footer
